import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/** Gate for authed routes. Two conditions:
 *   1. Signed in with a valid Cognito session (kicks off signIn() otherwise).
 *   2. Approved (in the beta or admin group) — otherwise route to /redeem.
 *  Backend still enforces both — this just avoids the flicker of a data
 *  fetch that would 403 immediately. */
const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { ready, isAuthenticated, isApproved, signIn } = useAuth();

  React.useEffect(() => {
    if (ready && !isAuthenticated) signIn();
  }, [ready, isAuthenticated, signIn]);

  if (!ready || !isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-space-950 text-white/60">
        <Loader2 className="h-6 w-6 animate-spin mr-2" />
        <span className="text-sm">Signing you in…</span>
      </div>
    );
  }
  if (!isApproved) {
    return <Navigate to="/redeem" replace />;
  }
  return <>{children}</>;
};

export default RequireAuth;
